/**
 * This is the home of the color picker library, for more information go to:
 * https://labs.abeautifulsite.net/jquery-minicolors/
 */

namespace appn.minicolors {
    export interface Swatches {
        name: string;
        color: string;
    }

    export class Options {
        constructor(change?: Function, hide?: Function, show?: Function) {
            this.change = change;
            this.hide = hide;
            this.show = show || handleColorPickerPosition;
        }

        animationSpeed: number = 50;
        animationEasing: string = 'swing';
        change?: Function;
        changeDelay: number = 150;
        control: string = 'hue';
        defaultValue: string = emptyString;
        canSave?: boolean = true;
        format: string = 'hex';
        hide?: Function;
        hideSpeed: number = 100;
        inline: boolean = false;
        keywords: string = emptyString;
        letterCase: string = 'uppercase';
        opacity: boolean = false;
        position: string = 'bottom left';
        show?: Function;
        showSpeed: number = 100;
        theme: string = 'default';
        swatches: Array<Swatches> = [];
    }

    const _defaults: Options = new Options(); 

    /**
     * The color picker init function.
     * 
     * @param change the on('change', function()) callback.
     * @param canSave undefined: true.
     * @param customSelector undefined: $('.colorPicker').
     */
    export function init(change?: Function, canSave?: boolean, customSelector?: JQuery<HTMLElement>, position?: string): void {
        _defaults.change = change ? change : undefined;
        _defaults.canSave = canSave !== undefined ? canSave : true;
        _defaults.position = position ?? _defaults.position;

        const cssSelector = customSelector ? customSelector : $('.colorPicker');

        if (!_defaults.canSave)
            cssSelector.attr('disabled', 'disabled');

        (cssSelector as any).minicolors(_defaults);
    }

    export function refreshPreviewBody(): void {
        const body: Array<string> = [];

        for (let i = 1; i < 3; i++) {
            body[i - 1] = String($(`#AppConfig_BackgroundColor${i}`).val());
            if (body[i - 1].length === 0)
                body[i - 1] = '#FFFFFF';
        }

        const gradientBody = `linear-gradient(top, ${body[0]} 0%, ${body[1]} 100%)`;
        const ieGradient = `progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr="${body[0]}", endColorstr="${body[1]}");/*For IE7-8-9*/`;

        // we need to use vendor prefixes
        $.each([emptyString, '-o-', '-moz-', '-webkit-', '-ms-'], function() {
            $('.deviceSkin-content-wrapper').css({ 'background-image': this + gradientBody });
        });

        $('.deviceSkin-content-wrapper').css({ filter: ieGradient });
    }

    export function refreshPreviewTitle() {
        const title: Array<string> = [];

        for (let i = 1; i < 4; i++) {
            title[i - 1] = String($(`#AppConfig_TitleColor${i}`).val());
            if (title[i - 1].length === 0)
                title[i - 1] = '#FFFFFF';
        }

        const gradientBody = `linear-gradient(top, ${title[0]} 0%, ${title[1]} 60%, ${title[2]} 100%)`;
        const ieGradient = `progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr="${title[0]}", endColorstr="${title[2]}");/*For IE7-8-9*/`;

        // we need to use vendor prefixes
        $.each(['', '-o-', '-moz-', '-webkit-', '-ms-'], function() {
            $('.previewTitle').css({ 'background-image': this + gradientBody });
        });

        $('.previewTitle').css({ filter: ieGradient });
    }

    // This targets on gruops of color pickers with more than 3 including 3
    export function toggleColorPickerMulti(customSelector?: JQuery<HTMLElement>) {
        const colorBoxMulti = customSelector ? customSelector : $('.minicolors .colorPickerMulti');

        colorBoxMulti.siblings('.minicolors-swatch').on('click', function() {
            if ($(this).siblings('.colorPickerMulti').is(':visible')) {
                $(this).siblings('.colorPickerMulti').hide();
                $(this).siblings('.minicolors-panel').hide();
            } else {
                $('.minicolors .colorPickerMulti').hide();
                $('.minicolors .minicolors-panel').hide();
                $(this).siblings('.colorPickerMulti').show().focus();
                $(this).siblings('.minicolors-panel').show();
            }
        });

        colorBoxMulti.on('blur', function() {
            $(this).hide();
        });
    }


    // Shared logic to determine if the color picker panel should open above or below
    // based on available screen space
    function handleColorPickerPosition(this: HTMLElement | HTMLInputElement) {
        const $input = $(this);
        const $container = $input.closest('.minicolors');

        if ($container.length === 0) return;

        const panelHeight = 150; // Standard height for the minicolors panel
        const rect = this.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Calculate space below the input element
        const spaceBelow = windowHeight - rect.bottom;

        // Toggle class based on available space
        const shouldFlip = spaceBelow < panelHeight;
        $container.toggleClass('force-open-above', shouldFlip);
    }
}
